import React from 'react';

const ArrowDownSvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path fill="#222" fillRule="nonzero" d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </g>
  </svg>
);

export default ArrowDownSvgIcon;
